import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Loadable from 'react-loadable';

import {connect} from '@stubhub/react-store-provider';

import content from './content';
import controller from './controller';
import {getTypesToInclude} from './utils';

import './index.scss';

const TrustMessage = Loadable({
  loader: () => import(/* webpackChunkName: "swi-TrustMessage" */ '@stubhub/react-trust-message'),
  loading: () => /* istanbul ignore next */ null,
});

const MoreInfo = (props) => {
  const {
    device,
    showLegal,
    showFaceValue,
    showNonOfficial,
    faceValue,
    preSelectIncludeFees,
    hideEstimatedFee,
    showPriceIncludeVAT,
    className,
  } = props;
  const isMobile = device && device.type === 'phone';
  const types = getTypesToInclude(props);
  const typeFilter = ({type}) => types.includes(type);
  const importantInfo = content(
    showLegal,
    isMobile,
    showFaceValue,
    faceValue,
    preSelectIncludeFees,
    hideEstimatedFee,
    showPriceIncludeVAT,
    showNonOfficial
  ).filter(typeFilter);

  return importantInfo && importantInfo.length ? (
    <div className={cs('MoreInfo', className)}>
      {importantInfo && importantInfo.length && importantInfo.map((item) => <TrustMessage key={item.key} {...item} />)}
    </div>
  ) : null;
};

MoreInfo.propTypes = {
  device: PropTypes.string,
  showLegal: PropTypes.bool,
  showFaceValue: PropTypes.bool,
  showNonOfficial: PropTypes.bool,
  faceValue: PropTypes.array,
  preSelectIncludeFees: PropTypes.bool,
  hideEstimatedFee: PropTypes.bool,
  showPriceIncludeVAT: PropTypes.bool,
  className: PropTypes.string,
};

export default connect(controller)(MoreInfo);
